import { type WithId } from "@client/types";
import Modules from "@common/components/Courses/Modules/component";
import * as React from "react";
import { type CourseDetail } from "../types";

export type MapProps = WithId & {
  activeItemIndex?: number;
  activeCourse: CourseDetail.CourseAppState | null;
  navigationType: CourseDetail.View.NavigatonType;
  modules: CourseDetail.CourseModule[];
  module: CourseDetail.CourseModule | null;
  style?: React.CSSProperties;
};
export interface ActionProps {
  onGoBack: () => void;
  onModuleSelected: (index: number) => void;
  onLessonClick: (id: string) => void;
}

export default (props: ActionProps & MapProps) => {
  return <Modules {...props} />;
};
